import { FC, useEffect, useState } from 'react';
import { ArrowDropDown as ArrowDropDownIcon, ArrowDropUp as ArrowDropUpIcon } from '@mui/icons-material';
import { List } from '@mui/material';
import { Link } from 'react-router-dom';
import { REPORTS_SLUG, WORKBOARD_SLUG } from 'dashboard409a/common/constants';
import { SlugState, useSlugDetector, WORKBOARD_SLUGS } from 'dashboard409a/hooks/useSlugDetector';
import {
  StyledCollapse,
  StyledItemLink,
  StyledListItem,
  StyledListItemText,
  StyledListItemWithLink,
  StyledListItemXs,
  StyledSubItem,
  StyledSubItemLink,
} from './styles';
import { ITopMenuItem } from './types';

const TopMenuItem: FC<ITopMenuItem> = props => {
  const { item } = props;
  const { slug, title, subMenu, isParent = false, url = '' } = item;
  const [isOpen, setIsOpen] = useState(false);
  
  const handleCollapse = () => {
    setIsOpen(previousState => !previousState);
  };

  const { slugState, location } = useSlugDetector();
  
  // Determine if the current item should be active based on slug state
  const active = (() => {
    if (slug === WORKBOARD_SLUG) {
      return WORKBOARD_SLUGS.includes(slugState);
    }
    if (slug === REPORTS_SLUG) {
      return slugState === SlugState.REPORTS_PAGE;
    }
    
    // Default active logic for other items
    return location.pathname.includes(slug);
  })();
  
  // Auto-expand submenu if the item is active
  useEffect(() => {
    if (active && isParent) {
      setIsOpen(true);
    }
  }, [active, isParent]);

  return (
    <>
      {isParent ? (
        <>
          <StyledListItemXs 
            id={`topMenuItem-${slug}-xs`} 
            onClick={handleCollapse}
            className={active ? 'active' : ''}
          >
            <StyledListItemText primary={title} />
            {isOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
          </StyledListItemXs>

          <StyledListItemWithLink 
            id={`topMenuItem-${slug}-md`}
            className={active ? 'active' : ''}
          >
            <StyledItemLink onClick={() => item.handleClick?.()}>
              <StyledListItemText primary={title} />
            </StyledItemLink>
          </StyledListItemWithLink>
        </>
      ) : (
        <StyledListItem 
          id={`topMenuItem-${slug}`}
          className={active ? 'active' : ''}
        >
          <Link to={url}>
            <StyledListItemText primary={title} />
          </Link>
        </StyledListItem>
      )}

      {subMenu && subMenu.length > 0 && (
        <StyledCollapse in={isOpen} timeout="auto" unmountOnExit>
          <List component="ul" disablePadding>
            {subMenu.map(subMenuItem => {
              const { slug: subMenuSlug, title: subMenuTitle } = subMenuItem;
              const isSubItemActive = location.pathname.includes(subMenuSlug);

              return (
                <StyledSubItem 
                  key={`subMenuItem-${subMenuSlug}`}
                  className={isSubItemActive ? 'active' : ''}
                >
                  <StyledSubItemLink to={subMenuSlug || '#'}>
                    <StyledListItemText primary={subMenuTitle} />
                  </StyledSubItemLink>
                </StyledSubItem>
              );
            })}
          </List>
        </StyledCollapse>
      )}
    </>
  );
};

export default TopMenuItem;
